import { useNavigate } from 'react-router-dom';
import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useUpdateProductConcern = () => {
  const navigate = useNavigate();
  
  const { setDataToServer } = useCreate({
    url: 'concern/update',
    refreshUrl: 'concern/list',
    onSuccess: () => {
      toast.success("Concern Updated Successfully", {
        position: "top-right",
        duration: 3000
      });
      navigate('/catalog/concerns');
    }
  });
  
  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useUpdateProductConcern;
